import styled from "styled-components";

/** Narrow screens: the 11 scores in two rows (0–5, 6–10) instead of one too tight to tap */
const TWO_ROWS = "480px";

export const Scale = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .values {
    display: grid;
    grid-template-columns: repeat(11, minmax(0, 1fr));
    gap: 0.25rem;

    @media (max-width: ${TWO_ROWS}) {
      grid-template-columns: repeat(6, minmax(0, 1fr));
      gap: 0.375rem;
    }
  }

  .labels {
    display: flex;
    justify-content: space-between;
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    color: var(--color-neutral-150);
  }
`;

export const ScaleValue = styled.button`
  height: 44px;
  font-family: Inter, sans-serif;
  font-size: 0.9375rem;
  font-weight: 800;
  color: var(--color-neutral-white);
  background: var(--color-neutral-darkness);
  border-radius: 10px;
  transition:
    background-color 0.15s,
    color 0.15s;

  &:hover,
  &:focus-visible {
    color: var(--color-neutral-darkness);
    background: var(--color-brand-plus);
    outline: none;
  }
`;

export const Field = styled.div`
  display: flex;

  textarea {
    width: 100%;
    min-height: 104px;
    padding: 0.75rem 1rem;
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: var(--color-neutral-white);
    resize: vertical;
    background: var(--color-neutral-darkness);
    border: 1px solid var(--color-neutral-base);
    border-radius: 12px;

    &:focus {
      border-color: var(--color-brand-plus);
      outline: none;
    }
  }
`;
